
import { useMfaStateContext } from '../MfaStateContext';

export function useBaseMfaState() {
  return useMfaStateContext();
}
